/* tslint:disable */
/* eslint-disable */
/**
 * Kapybro Frontend Api Service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: hello@roguepaws.dev
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum SubscriptionState {
    ACTIVE = 'ACTIVE',
    PAST_DUE = 'PAST_DUE',
    CANCELED = 'CANCELED',
    TRIALING = 'TRIALING'
}

export function SubscriptionStateFromJSON(json: any): SubscriptionState {
    return SubscriptionStateFromJSONTyped(json, false);
}

export function SubscriptionStateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionState {
    return json as SubscriptionState;
}

export function SubscriptionStateToJSON(value?: SubscriptionState | null): any {
    return value as any;
}

